import React from 'react'
import FieldCrmContactType_Value from "./value"

// the color box of the contact with no type - the popover option uses it too
export const NO_TYPE_COLOR = 6

// the contact with no type set - there is no such option in the company settings
export default function FieldCrmContactType_ValueEmpty(props: any) {

    const option = {label: props.field.noValueOptionLabel, color: NO_TYPE_COLOR}

    return (
        <FieldCrmContactType_Value
            option          = {option}
            size            = {props.size}
            disabled        = {props.disabled}
            className       = {props.className}
            labelClassName  = {props.configOptions?.labelClassName}
            onClick         = {props.onClick}
        >
            {props.children}
        </FieldCrmContactType_Value>
    )
}
